import { render, staticRenderFns } from "./AddToCartLink.vue?vue&type=template&id=16fe8842&scoped=true"
import script from "./AddToCartLink.vue?vue&type=script&lang=ts"
export * from "./AddToCartLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fe8842",
  null
  
)

export default component.exports